<template>
  <div class="attendee-container">
    <slot></slot>
  </div>
</template>

<style lang="scss">
  .attendee-container{
    max-width: var(--attendee-container-width);
    padding: 0 var(--attendee-gap-md);
    //margin: 0 auto;
  }
</style>

<script>
export default {

}
</script>